var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb max-width"},_vm._l((_vm.breadcrumb),function(item,index){return _c('span',{key:item.path,staticClass:"breadcrumb-item pointer",class:{ current: index === _vm.breadcrumb.length - 1 },on:{"click":function($event){return _vm.handleClick(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }